import React, { useEffect, useState } from 'react';
import { useLocation,useNavigate,Link } from 'react-router-dom';
import { fetchCourseDetails, submitAnswers } from '../services/userApi'; // ตรวจสอบเส้นทางให้ถูกต้อง
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import backgroundImage from '../assets/Bg.jpg';
import backgroundContainer from '../assets/contentbg.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass,
         faXmark,
         faMagnifyingGlassPlus,
         faMagnifyingGlassMinus
        } from '@fortawesome/free-solid-svg-icons';


const TestPage = () => {
  const MySwal = withReactContent(Swal);
  const location = useLocation();
  const navigate = useNavigate();
  const { testUid, courseUid } = location.state || {};

  const [testData, setTestData] = useState({ questions: [] });
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const accessToken = JSON.parse(localStorage.getItem('account'))?.access_token;
  const [user, setUser] = useState(null);

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1025);
  const handleResize = () => {
    setIsSmallScreen(window.innerWidth < 1025);
};

const [currentPage, setCurrentPage] = useState(1); // จัดการหมายเลขหน้า
const [pageSize] = useState(1); // ขนาดของข้อมูลต่อหน้า
const [totalPages, setTotalPages] = useState(Math.ceil(testData.questions.length / pageSize)); // คำนวณจำนวนหน้าจากคำถามทั้งหมด

const [isModalOpen, setIsModalOpen] = useState(false);
const [zoomLevel, setZoomLevel] = useState(1)

const [unansweredQuestions, setUnansweredQuestions] = useState([]);
const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false); // สถานะสำหรับ Modal ยืนยันการส่ง
const [isUnansweredModalVisible, setIsUnansweredModalVisible] = useState(false); // สถานะสำหรับ Modal คำถามที่ยังไม่ได้ตอบ

useEffect(() => {
  // เรียกข้อมูลและตั้งค่า testData
  getCourseDetails();

  // คำนวณจำนวนหน้าใหม่
  setTotalPages(Math.ceil(testData.questions.length / pageSize)); // คำนวณจำนวนหน้าจากข้อมูลคำถามจริง ๆ

  fetchUserData();

  window.addEventListener('resize', handleResize);

  return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('resize', handleResize);
  };
}, [courseUid, accessToken, testUid, testData.questions.length]); // เพิ่มการฟังการเปลี่ยนแปลง testData.questions.length


  const getCourseDetails = async () => {
    try {
        if (!courseUid) {
            throw new Error('Course ID is missing.');
        }

        if (!accessToken) {
            throw new Error('Access token is missing.');
        }

        console.log('Calling fetchCourseDetails with courseId:', courseUid);

        const response = await fetchCourseDetails(courseUid, accessToken);
        console.log('API Response:', response);

        const { data } = response;

        // ตรวจสอบว่า data มี tests และ tests เป็นอาเรย์
        if (data.tests && Array.isArray(data.tests) && data.tests.length > 0) {
            const test = data.tests.find(t => t.uid === testUid); // ใช้ testId ที่ถูกต้อง
            if (test) {
                if (Array.isArray(test.questions) && test.questions.length > 0) {
                    setTestData({ questions: test.questions });
                } else {
                    throw new Error('Questions format is invalid or empty.');
                }
            } else {
                throw new Error('Test ID not found.'); // ตรวจสอบว่ามีการค้นหาแบบทดสอบที่ถูกต้อง
            }
        } else {
            throw new Error('Invalid tests format received.');
        }
    } catch (error) {
        console.error('Error fetching course details:', error);
        setError(error.message);
    } finally {
        setLoading(false);
    }
};

const fetchUserData = async () => {
  try {
      const userData = JSON.parse(localStorage.getItem('account'));
      if (userData) {
          setUser(userData);
      }
  } catch (error) {
      console.error('Failed to fetch user data:', error);
  }
};

  const onError = (title,response) => {
    MySwal.fire({
        title: title,
        html: response?.data?.error?.message,
        icon: "error",
        confirmButtonText: "Close",
        allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
          if(response?.status===401) {
              sessionStorage.removeItem('hasVisited');
              sessionStorage.removeItem('lastPath');        
              localStorage.removeItem('account');                  
              navigate('/');
          };
      }
    });
};

const handleAnswerSelection = (questionId, answerId) => {
  setSelectedAnswers(prev => ({ 
    ...prev, 
    [questionId]: {
      option_id: answerId, // เก็บ option_id ที่เลือก
      answer: prev[questionId]?.answer || null // เก็บ answer ถ้ามี
    }
  }));
};

// ฟังก์ชันสำหรับจัดการการกรอกข้อความใน textarea
const handleTextAnswer = (questionId, answerText) => {
  setSelectedAnswers(prev => ({
    ...prev,
    [questionId]: {
      option_id: prev[questionId]?.option_id || null, // เก็บ option_id ที่เลือกไว้
      answer: answerText // เก็บคำตอบที่กรอกใน textarea
    }
  }));
};

// ฟังก์ชันตรวจสอบการตอบคำถาม
const handleConfirmSubmit = () => {
  const unanswered = [];

  // ตรวจสอบคำถามทั้งหมดใน 'testData.questions'
  testData.questions.forEach(question => {
    if (question.type === "1") { // คำถามประเภทที่มีตัวเลือก
      if (!selectedAnswers[question.question_id]) {
        unanswered.push(question.question_id); // ถ้ายังไม่ได้ตอบ
      }
    } else if (question.type === "2") { // คำถามประเภทที่กรอกคำตอบเอง
      if (!selectedAnswers[question.question_id]?.answer) {
        unanswered.push(question.question_id); // ถ้ายังไม่ได้กรอกคำตอบ
      }
    }
  });

  if (unanswered.length > 0) {
    // ถ้ามีคำถามที่ยังไม่ได้ตอบ
    setUnansweredQuestions(unanswered);
    setIsUnansweredModalVisible(true); // เปิด Modal สำหรับคำถามที่ยังไม่ได้ตอบ
    setIsConfirmModalVisible(false); // ปิด Modal ยืนยันการส่ง
  } else {
    // ถ้าตอบครบแล้ว
    setIsUnansweredModalVisible(false); // ปิด Modal คำถามที่ยังไม่ได้ตอบ
    setIsConfirmModalVisible(true); // เปิด Modal ยืนยันการส่ง
  }
};

// ฟังก์ชันยืนยันการส่งคำตอบ
const handleModalConfirm = () => {
  handleSubmit(); // ส่งคำตอบ
  setIsConfirmModalVisible(false); // ปิด Modal ยืนยันการส่ง
};

// ฟังก์ชันยกเลิก Modal
const handleModalCancel = () => {
  setIsConfirmModalVisible(false); // ปิด Modal ยืนยันการส่ง
  setIsUnansweredModalVisible(false); // ปิด Modal คำถามที่ยังไม่ได้ตอบ
};

const handleSubmit = async () => {
  try {
      if (!accessToken) {
          throw new Error('Access token is missing.');
      }

      // สร้าง answersArray โดยรวมทั้ง option_id และ answer
      const answersArray = Object.keys(selectedAnswers).map(questionId => {
          const answerData = selectedAnswers[questionId];

          // กำหนดค่า option_id หรือ answer ตามที่มี
          return {
              question_id: questionId, // ใช้ questionId เป็น string
              option_id: answerData.option_id || null, // ใช้ option_id ถ้ามี
              answer: answerData.answer || null // ใช้ answer ถ้ามี
          };
      }).filter(answer => answer.option_id !== null || answer.answer !== null); // กรองเฉพาะคำตอบที่มีค่า

      if (!testUid || !courseUid) {
          throw new Error('Test UID or Course UID is missing.');
      }

      // สร้าง payload สำหรับส่งไปยัง API
      const payload = {
          test_uid: testUid, // ใช้ testUid ที่กำหนดไว้
          answers: answersArray // ส่ง answersArray ที่สร้างขึ้น
      };

      // ตรวจสอบ payload
      console.log('Payload:', payload); // ตรวจสอบค่าที่จะส่งไป

      // ส่ง payload ไปยัง API
      const response = await submitAnswers(testUid, answersArray, accessToken);
      console.log('API Response:', response);

      const score = response.data.account_test.total_score; // ใช้ total_score จาก account_test
      const answers = response.data.account_test.answers; // ดึงคำตอบเพื่อดูคะแนนของแต่ละข้อ

      Swal.fire({ 
        title: 'ส่งแบบทดสอบ!',
        text: 'คุณได้ทำการส่งแบบทดสอบเรียบร้อยแล้ว',
        icon: 'success',
        confirmButtonText: 'กลับสู่หน้าบทเรียน',
         confirmButtonColor: '#44526E'
    }).then((result) => {
        if (result.isConfirmed) {
            navigate('/course', { state: { courseUid: courseUid ,activeTab: 'tests'} });
        }
    });

  } catch (error) {
      console.error('Error submitting answers:', error);
      onError("ไม่สามารถส่งข้อสอบได้", error?.response || { data: { error } });
  }
};

const handleNextQuestion = () => { 
  if (currentQuestionIndex < testData.questions.length - 1) {
    setCurrentQuestionIndex(prevIndex => prevIndex + 1);
    // เพิ่มการเปลี่ยนหน้า
    setCurrentPage(prevPage => prevPage + 1);
  }
};

const handlePreviousQuestion = () => {
  if (currentQuestionIndex > 0) {
    setCurrentQuestionIndex(prevIndex => prevIndex - 1);
    // เพิ่มการเปลี่ยนหน้า
    setCurrentPage(prevPage => prevPage - 1);
  }
};

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  const currentQuestion = testData.questions[currentQuestionIndex] || {};

  const getPaginationItems = () => {
    const pages = [];
    const maxPagesToShow = 10;
    const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);
    
    let startPage = Math.max(1, currentPage - halfMaxPagesToShow);
    let endPage = Math.min(totalPages, currentPage + halfMaxPagesToShow);
    
    if (currentPage - halfMaxPagesToShow <= 0) {
      endPage = Math.min(totalPages, endPage + (halfMaxPagesToShow - currentPage + 1));
    }
    
    if (currentPage + halfMaxPagesToShow >= totalPages) {
      startPage = Math.max(1, startPage - (halfMaxPagesToShow - (totalPages - currentPage)));
    }
    
    for (let page = startPage; page <= endPage; page++) {
      pages.push(page);
    }
  
    return pages;
  };
const onPageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
        setCurrentPage(page); // เปลี่ยนหน้าปัจจุบัน
        console.log("Switched to page:", page);
        setCurrentQuestionIndex((page - 1) * pageSize); // ปรับ index คำถามให้ตรงกับหน้าที่เลือก
    }
};

    // ฟังก์ชันสำหรับเปิด modal
    const openModal = () => {
      setIsModalOpen(true);
  };

  // ฟังก์ชันสำหรับปิด modal
  const closeModal = () => {
      setIsModalOpen(false);
  };

      // ฟังก์ชันสำหรับขยายภาพ
      const zoomIn = () => {
        setZoomLevel(zoomLevel + 0.1); // เพิ่มขนาดภาพขึ้นทีละ 10%
    };

    // ฟังก์ชันสำหรับย่อภาพ
    const zoomOut = () => {
        setZoomLevel(zoomLevel - 0.1); // ลดขนาดภาพลงทีละ 10%
    };

  return (
    <div>
      <div style={styles.background}></div>
      <div style={styles.container}>
        
      {currentQuestion ? (
          <div style={{
          
              borderRadius: '36px',
              padding: '18px',
              width:'100%',
              boxSizing:'border-box',
              
          }}>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems:'center',
              boxSizing:'border-box'
            }}>
              <div style={styles.containerQuest}>
                <div>
                  {getPaginationItems().map(page => (
                      <button 
                          key={page} 
                          onClick={() => onPageChange(page)} 
                          disabled={page === currentPage}
                          style={{ 
                              padding: '10px', 
                              margin: '0 5px', 
                              backgroundColor: page === currentPage ? '#44526e' : '#fff',
                              color: page === currentPage ? 'white' : '#44526e',
                              border: '1px solid #ccc',
                              borderRadius: '50%',
                              cursor: 'pointer',
                              fontSize:'24px',
                              width:'56px'
                          }}
                      >
                          {page}
                      </button>
                  ))}
              </div>
              <div style={{ flexShrink: 0 , paddingTop:'20px'}}>  
                  </div>
                <div style={{
                  display:'flex',
                  width:'100%',
                  gap:'20px',
                  alignItems:'center'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(90deg, #7C93B7 0%, #374151 100%)',
                    borderRadius: '36px',
                    width: '100%',
                    color: '#fff',
                    fontSize: '24px',
                    padding: '20px',
                    boxSizing: 'border-box',
                  
                    height:'auto'
                  }}>
                   <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <p style={{ margin: 0, wordWrap: 'break-word', textAlign: 'center', flexGrow: 1 }}>
                            คำถามที่ {currentQuestionIndex + 1}: {currentQuestion.question_text}
                        </p>
                        <p style={{ margin: 0, textAlign: 'right', paddingRight: '8px' }}>
                            {currentQuestionIndex + 1}/{testData.questions.length}
                        </p>
                    </div>
                  </div>
                </div>
              
                <div style={styles.imgPlace}>
                {currentQuestion.image_url && (
                  <>
                    <img
                      src={currentQuestion.image_url}
                      style={{
                        width: '100%',
                        maxHeight: '400px',
                        objectFit: 'contain',
                        margin: '20px 0',
                        borderRadius: '36px',
                      }}
                      alt="question"
                    />
                    <div style={styles.zoom}>
                      <button
                        onClick={openModal}
                        style={styles.btnZoom}
                      >
                        <span style={{ fontSize: '24px', }}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} style={{  color: '#F9FAFB' }} />
                        </span>
                      </button>
                    </div>
                  </>
                )}
              </div>
                {currentQuestion.type === "1" && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                    {currentQuestion.options.map((option, index) => (
                      <button
                        key={option.option_id}
                        onClick={() => handleAnswerSelection(currentQuestion.question_id, option.option_id)}
                        style={{
                          padding: '20px',
                          backgroundColor: selectedAnswers[currentQuestion.question_id]?.option_id === option.option_id 
                            ? ['#C3FFCC', '#C3FFCC', '#C3FFCC', '#C3FFCC'][index % 4] // สีเขียวถ้าเลือก
                            : ['#ffffff','#ffffff','#ffffff','#ffffff'][index % 4], // สีเริ่มต้นตามอาเรย์
                          borderRadius: '30px',
                          cursor: 'pointer',
                          fontSize: '16px',
                          color: '#333',
                          fontWeight: 'bold',
                          margin:' 0px 0px 20px 0px',
                          width: '100%',
                          border: selectedAnswers[currentQuestion.question_id]?.option_id === option.option_id 
                            ? '2px solid #218730' // เงาเมื่อเลือก
                            : '2px solid white', // ไม่มีเงาเมื่อไม่เลือก
                          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                        }}
                      >
                        {option.option_text}
                      </button>
                    ))}
                  </div>
                )}
                {currentQuestion.type === "2" && (
                  <textarea
                  value={selectedAnswers[currentQuestion.question_id]?.answer || ''}
                  placeholder="คำตอบ..."
                  onChange={(e) => handleTextAnswer(currentQuestion.question_id, e.target.value)}
                  style={{
                    width:'100%',
                    border:'none',
                    boxSizing:'border-box',
                    height:'150px',
                    resize: 'vertical',
                    padding:'20px',
                    fontSize:'16px',
                    marginBottom:'20px',
                    borderRadius:'20px',
                    background:'white',
                    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                  }}
                />  
                )}
             <div style={styles.btnNextPrev}>
              <button 
                onClick={handlePreviousQuestion}
                style={styles.buttonPrev}
                aria-label="Previous question"
              >
                ก่อนหน้า
              </button>
                {currentQuestionIndex < testData.questions.length - 1 ? (
                  <button 
                    onClick={handleNextQuestion}
                    style={styles.buttonStyle}
                    aria-label="Next question"
                  >
                    ถัดไป
                  </button>
                ) : (
                  <button 
                    onClick={handleConfirmSubmit}
                    style={styles.buttonStyle}
                    aria-label="Submit answers"
                  >
                    ส่งคำตอบ
                  </button>
                )}
            </div>

              </div>
            </div>
          </div>
        ) : null}
      </div>

        {/* Modal สำหรับแสดงภาพขยาย */}
        {isModalOpen && (
                <div style={styles.contentZoom}>
                    <div
                        style={{
                            position: 'relative',
                        }}
                    >
                        <img
                            src={currentQuestion.image_url}
                            alt="Expanded"
                            style={{
                                transform: `scale(${zoomLevel})`,
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                                transition: 'transform 0.2s ease-in-out', // ให้ภาพขยายหรือย่อได้อย่างนุ่มนวล
                            }}
                        />
                    </div>
                    <div style={styles.btnzoomAll}>
                      <button
                            onClick={closeModal}
                            style={styles.detailBtn}
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                        <button
                            onClick={zoomIn}
                            style={styles.detailBtn}
                        >
                            <FontAwesomeIcon icon={faMagnifyingGlassPlus} />
                        </button>
                        <button
                            onClick={zoomOut}
                            style={styles.detailBtn}
                        >
                            <FontAwesomeIcon icon={faMagnifyingGlassMinus} />
                        </button>
                    </div>
                </div>
            )}
          {/* Modal สำหรับยืนยันการส่งคำตอบ */}
          {isConfirmModalVisible && (
            <div style={styles.modalStyles}>
              <div style={styles.modalContentStyles}>
                <h2>คุณยืนยันจะส่งคำตอบใช่หรือไม่</h2>
                <div style={{ display: 'flex', margin: '10px 0', gap: '8px' }}>
                  <button onClick={handleModalCancel} style={styles.buttonCancelStyles}>ย้อนกลับ</button>
                  <button onClick={handleModalConfirm} style={styles.buttonStyles}>ส่งคำตอบ</button>
                </div>
              </div>
            </div>
          )}

          {/* Modal สำหรับกรณียังไม่ตอบคำถามครบ */}
          {isUnansweredModalVisible && (
            <div style={styles.modalStyles}>
              <div style={styles.modalContentStyles}>
                <h2>คุณยังไม่ตอบคำถาม</h2>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }}>
                  {unansweredQuestions.map((questionId, index) => (
                    <p key={index} style={styles.numberPage}>{`${questionId}`}</p>
                  ))}
                </div>
                <div style={{ display: 'flex', margin: '10px 0', gap: '8px' }}>
                  <button onClick={handleModalCancel} style={styles.buttonCancelStyles}>ย้อนกลับ</button>
                  <button onClick={handleModalConfirm} style={styles.buttonStyles}>ส่งคำตอบ</button>
                </div>
              </div>
            </div>
          )}
    </div>
  )
}

const styles={
  buttonStyle: {
    flex: 1,  // ให้ปุ่มใช้พื้นที่เท่ากัน
    padding: '10px',
    backgroundColor: '#44526E',
    color: 'white',
    border: 'none',
    borderRadius: '100px',
    cursor: 'pointer',
    fontSize: '18px',
    boxSizing: 'border-box',
    textAlign: 'center',  // จัดข้อความให้อยู่ตรงกลาง
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  buttonPrev: {
    flex: 1,  // ให้ปุ่มใช้พื้นที่เท่ากัน
    padding: '10px',
    backgroundColor: 'white',
    color: '#44526E',
    border: 'none',
    borderRadius: '100px',
    cursor: 'pointer',
    fontSize: '18px',
    boxSizing: 'border-box',
    textAlign: 'center',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  btnNextPrev: {
    display: 'flex',      // ใช้ flexbox เพื่อจัดปุ่มให้อยู่ข้างกัน
    gap: '24px',          // ระยะห่างระหว่างปุ่ม
    width: '100%',
  },
  container: {
    display: 'flex', // ใช้ flexbox
    flexDirection: 'column', // แนวตั้ง
    justifyContent: 'flex-start', // จัดให้ชิดด้านบน
    alignItems: 'center', // จัดกลางในแนวนอน
    textAlign: 'center',
    padding: '20px',
    padding:'90px 0',
    marginBottom: '0', // ป้องกันการมีที่ว่างด้านล่าง
    minHeight: '50.5vh', // กำหนดความสูงขั้นต่ำ
    width:'100%',
     boxSizing:'border-box'
  },
  containerQuest:{
    flex: 1, 
    margin: '0 20px' ,
    boxSizing:'border-box',
    padding:'20px',
    borderRadius:'20px',
    width:'100%',
     wordWrap: 'break-word',
    background: '#FFFFFFB2'
  },
  background: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
    backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.25)), url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    zIndex: '-1',
    boxSizing: 'border-box'
  },
  imgPlace:{
    marginBottom: '20px', 
    display: 'flex', 
    justifyContent: 'center',
    background:'white',
    position: 'relative', 
    borderRadius:'36px'
  },
  btnZoom:{
    padding: '10px 16px',
    backgroundColor: '#44526e',
    color: 'white',
    border: 'none',
    borderRadius: '100px',
    cursor: 'pointer',
    fontSize: '16px',
  },
  zoom:{
    position: 'absolute', 
    bottom: '10px', 
    right: '10px',
  },
  contentZoom:{
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '1000',
    display:'flex'
  },
  btnzoomAll:{
    position: 'absolute',  // ใช้ absolute เพื่อกำหนดตำแหน่งอย่างอิสระ
    top: '10px',           // ให้ปุ่มอยู่ห่างจากขอบบน 10px
    right: '10px',         // ให้ปุ่มอยู่ห่างจากขอบขวา 10px
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column', // เรียงปุ่มในแนวตั้ง
    alignItems: 'center', 
    justifyContent: 'flex-start', // จัดปุ่มให้ชิดด้านบน
    gap:'10px'
  },
  detailBtn:{
    background: '#44526e',
    color: 'white',
    border: 'none',
    padding: '10px 15px',
    borderRadius: '50%',
    cursor: 'pointer',
    width:'100%',
    fontSize:'24px'
  },
  modalStyles: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000, // เพื่อให้ Modal อยู่เหนือส่วนอื่นๆ
  },
  modalContentStyles: {
    backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.025)), url(${backgroundContainer})`,
    backgroundSize: 'cover', // ให้ภาพครอบคลุมพื้นที่
    backgroundPosition: 'center', // ให้ภาพอยู่ตรงกลาง
    padding: '20px',
    borderRadius: '8px',
    width: '50%',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    boxSizing: 'border-box'
  },
  
  buttonStyles: {
    padding: '10px 24px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '100px',
    cursor: 'pointer',
    backgroundColor: '#44526e',
    color: 'white',
    transition: 'background-color 0.3s ease',
    width:'100%'
  },
  buttonCancelStyles: {
    padding: '10px 24px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '100px',
    cursor: 'pointer',
    backgroundColor: 'white',
    color: '#44526e',
    transition: 'background-color 0.3s ease',
    width:'100%'
  },
  buttonStylesHover: {
    backgroundColor: '#45a049', // สีเขียวเข้มเมื่อ hover
  },
  numberPage: {
    padding: '10px', 
    margin: '0 5px', 
    backgroundColor: '#fff',
    color: '#44526e',
    borderRadius: '50%',
    fontSize: '24px',
    width: '40px',      // กำหนดความกว้าง
    height: '40px',     // กำหนดความสูง
    display: 'flex',    // ใช้ flexbox เพื่อจัดศูนย์ข้อความ
    justifyContent: 'center', // จัดแนวข้อความในแนวนอน
    alignItems: 'center',     // จัดแนวข้อความในแนวตั้ง
  }
  
}

export default TestPage;
